import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

type Role = APIResponse<'/api/v4/roles'>[number];

export const fetchRoles = async () => get<Role[]>('/v4/roles');
